// extracted by mini-css-extract-plugin
export default {"save-project-link":"save-project-link_save-project-link__sM03M","btn":"save-project-link_btn__NoHva","save-project-empty-holder":"save-project-link_save-project-empty-holder__hJO9b"};